import React from 'react';

import { useToast } from '@chakra-ui/react';

import { deleteSkus } from 'api/sku';
import { useMutation, useQueryClient } from 'react-query';

import { SkuProps } from './Sku.props';

import SkuView from './Sku.view';

const SkuContainer = (_: SkuProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate, isLoading: isDeleting } = useMutation(deleteSkus);

  const _props = {
    isDeleting,
    onDelete: (ids: string[], type: string, _onSuccess: () => void) =>
      mutate(ids, {
        onSuccess: () => {
          toast({
            duration: 3000,
            title: 'Success',
            isClosable: true,
            status: 'success',
            description: `SKU ${
              type.charAt(0).toUpperCase() + type.slice(1)
            }s Deleted`,
          });

          const queryKey = `fetch-all-sku-${type}`;

          queryClient.invalidateQueries(queryKey);

          _onSuccess();
        },
      }),
  };

  return <SkuView {..._props} />;
};

export default SkuContainer;
